"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.charts = void 0;
const conversions_1 = require("./conversions");
const revenue_1 = require("./revenue");
const roas_1 = require("./roas");
const sessions_1 = require("./sessions");
exports.charts = {
    revenueChart: {
        name: 'Revenue',
        query: revenue_1.revenueChart,
    },
    chartsROAS: {
        name: 'ROAS, %',
        query: roas_1.roasChart,
    },
    chartsSessions: {
        name: 'Sessions',
        query: sessions_1.sessionsChart,
    },
    conversionsChart: {
        name: 'Conversions',
        query: conversions_1.conversionsChart,
    },
};
//# sourceMappingURL=index.js.map